import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6540bb18"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ins-banner detail-banner" }
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "meng" }, null, -1))
const _hoisted_4 = { class: "bread padding" }
const _hoisted_5 = { class: "bd" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("首页")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("产品")
const _hoisted_8 = {
  key: 0,
  class: "pro-dt padding"
}
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        src: _ctx.banner.image,
        alt: "",
        class: "img"
      }, null, 8, _hoisted_2),
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_router_link, { to: "" }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, { to: "/product" }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }),
          _createElementVNode("span", null, _toDisplayString(_ctx.banner.title), 1)
        ])
      ])
    ]),
    (_ctx.banner.qt == 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("div", {
            class: "desc",
            innerHTML: _ctx.banner.cpjs
          }, null, 8, _hoisted_9)
        ]))
      : _createCommentVNode("", true),
    (_ctx.banner.qt == 1)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "pro-tu",
          innerHTML: _ctx.banner.qtnr
        }, null, 8, _hoisted_10))
      : _createCommentVNode("", true),
    _createVNode(_component_Footer)
  ], 64))
}